import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  useScrollTrigger,
  Slide,
} from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../assets/images/companylogo.png";

const navItems = [
  { text: "Home", path: "/" },
  { text: "About", path: "/about" },
  { text: "Services", path: "/services" },
  { text: "Contact", path: "/contact" },
];

// Hide AppBar on scroll down
function HideOnScroll({ children }) {
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export default function Navbar() {
  const [elevate, setElevate] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setElevate(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <HideOnScroll>
      <AppBar
        position="fixed"
        elevation={elevate ? 4 : 0}
        sx={{
          background: elevate
          ?"transparent"
          :"transparent",
            // ? "linear-gradient(to right, #7AB2D3, #8ae97d, #7AB2D3, #8ae97d, #7AB2D3)"
            // : "linear-gradient(to right, #7AB2D3, #8ae97d )",
          transition: "all 0.3s ease",
          backdropFilter: elevate ? "blur(8px)" : "none",
        }}
      >

        <Toolbar sx={{ justifyContent: "space-between", px: { xs: 2, md: 6 } }}>
          {/* Logo */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Claysoft Logo"
              sx={{ width: 160, height: "auto" , width:"230px" }}
            />
          </Box>

          {/* Nav Items */}
          <Box>
            {navItems.map((item) => (
              <Button
                key={item.text}
                component={Link}
                to={item.path}
                sx={{
                  mx: 1,
                  fontWeight: 500,
                  color: "#fff",
                  fontSize: "1rem",
                  textTransform: "uppercase",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    color: "#DDEFFF",
                    borderBottom: "2px solid #DDEFFF",
                    borderRadius: 0,
                  },
                }}
              >

                {item.text}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  );
}
